export default __webpack_public_path__ + "static/media/DB_7.e622d422.png";